import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { communityCategories } from "@/mocks/categories";

const accentStyles: Record<string, { bubble: string; chip: string }> = {
  primary: {
    bubble: "bg-primary-100 text-primary-700",
    chip: "bg-primary-100 text-primary-800",
  },
  accent: {
    bubble: "bg-accent-100 text-accent-700",
    chip: "bg-accent-100 text-accent-800",
  },
  secondary: {
    bubble: "bg-secondary-100 text-secondary-700",
    chip: "bg-secondary-100 text-secondary-800",
  },
};

export default function CategorySection() {
  return (
    <section className="w-full bg-background-50">
      <div className="max-w-content mx-auto px-4 md:px-8 py-14 md:py-20">
        <SectionHeading
          kicker="Browse By Topic"
          title="按分类逛，总有一款合口味"
          desc="从邻里街角到工位日常，八个小板块各自热闹。点进去就能看到该分类下被顶得最高的帖子。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {communityCategories.map((cat) => {
            const style = accentStyles[cat.accent];
            return (
              <Link
                key={cat.slug}
                to={`/hot?category=${cat.slug}`}
                className="group flex flex-col p-5 md:p-6 bg-background-100 border border-background-200 rounded-lg hover:border-primary-300 hover:bg-background-50 transition-colors cursor-pointer"
              >
                <span className={`w-11 h-11 rounded-md flex items-center justify-center ${style.bubble}`}>
                  <i className={`${cat.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {cat.name}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{cat.desc}</p>
                <span className="mt-5 flex items-center justify-between">
                  <span className={`px-2.5 py-1 rounded-md text-xs font-medium ${style.chip}`}>
                    {cat.count} 条内容
                  </span>
                  <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-primary-600 transition-colors"></i>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}